import { Link } from "react-router-dom";
import { NAV, NICE_NAV } from "@/data/content";

export const Footer = () => (
  <footer data-testid="site-footer" className="relative border-t border-vv-border bg-vv-surface/40 mt-24">
    <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-16 grid md:grid-cols-4 gap-10">
      <div className="md:col-span-2">
        <div className="flex items-center gap-2">
          <span className="w-2.5 h-2.5 rounded-full bg-vv-accent accent-glow" />
          <span className="font-display font-extrabold text-xl tracking-tight">VIGYAVED HEALTHCARE</span>
        </div>
        <p className="mt-4 max-w-md text-vv-muted text-sm leading-relaxed">
          Building intelligent healthcare for longer, healthier lives. Integrating medicine, data,
          artificial intelligence, environmental science and preventive health.
        </p>
        <p className="mt-6 font-mono text-xs text-vv-muted">Predict disease. Personalize care. Extend healthspan.</p>
      </div>
      <div>
        <div className="text-[10px] font-mono tracking-[0.2em] text-vv-muted mb-4">VIGYAVED</div>
        <ul className="space-y-2">
          {NAV.map((n) => (
            <li key={n.to}><Link to={n.to} className="text-sm text-vv-fg/70 hover:text-vv-accent transition-colors">{n.label}</Link></li>
          ))}
          <li><Link to="/investigators" className="text-sm text-vv-fg/70 hover:text-vv-accent transition-colors">Investigators</Link></li>
        </ul>
      </div>
      <div>
        <div className="text-[10px] font-mono tracking-[0.2em] text-vv-muted mb-4">NICE</div>
        <ul className="space-y-2">
          {NICE_NAV.slice(0, 6).map((n) => (
            <li key={n.to}><Link to={n.to} className="text-sm text-vv-fg/70 hover:text-vv-accent transition-colors">{n.label}</Link></li>
          ))}
          <li><Link to="/nice/webapps" className="text-sm text-vv-fg/70 hover:text-vv-accent transition-colors">WebApps by Vigyaved</Link></li>
          <li><Link to="/pricing" className="text-sm text-vv-fg/70 hover:text-vv-accent transition-colors">Pricing</Link></li>
        </ul>
      </div>
    </div>
    <div className="border-t border-vv-border">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-6 flex flex-col sm:flex-row justify-between gap-3 text-xs text-vv-muted">
        <span>© {new Date().getFullYear()} Vigyaved Healthcare. All rights reserved.</span>
        <div className="flex flex-wrap gap-x-5 gap-y-1">
          <Link to="/about" className="hover:text-vv-accent transition-colors" data-testid="footer-about">About Us</Link>
          <Link to="/contact" className="hover:text-vv-accent transition-colors" data-testid="footer-contact">Contact Us</Link>
          <Link to="/pricing" className="hover:text-vv-accent transition-colors" data-testid="footer-pricing">Pricing</Link>
          <Link to="/privacy" className="hover:text-vv-accent transition-colors" data-testid="footer-privacy">Privacy Policy</Link>
          <Link to="/terms" className="hover:text-vv-accent transition-colors" data-testid="footer-terms">Terms &amp; Conditions</Link>
          <Link to="/refund-policy" className="hover:text-vv-accent transition-colors" data-testid="footer-refund">Cancellation/Refund</Link>
        </div>
      </div>
    </div>
  </footer>
);
